//--------------------------------------------
//
// Timeline Elements
//
//--------------------------------------------
'use strict';

import q from 'q';
import moment from 'moment';
import RandomUser from './RandomUser';
import RandomPhoto from './RandomPhoto';
import AudioManager from './AudioManager';

class TimelinePost {

	constructor(scene){
		//three instance used to generate sprites on click
		this.scene = scene;
		

		this.container = document.getElementById('timeline-container');
		this.person = null;
		this.photo = null;
		this.message = null;
		this.parent = null;
		this.visible = false;
		this.deferred = q.defer();
		this.init();

		return this.deferred.promise;
	}


	init(){

		//--------------------------------------------
		// Get random person
		//
		const self = this;

		new RandomUser().then((user) => {
			self.person = user;
			self.photo = RandomPhoto[Math.floor(Math.random() * RandomPhoto.length)];

			self.createDom();
		});
	}

	createDom(){
		const self = this;

		//make li
		this.parent = document.createElement('li');
		this.parent.classList.add('timeline-block');
		this.container.appendChild(this.parent);

		this.parent.addEventListener('click', this.onClick.bind(this), false);

		//make top info section
		const info = document.createElement('div');
		info.classList.add('timeline-block-info');
		this.parent.appendChild(info);

		//make top info image
		const infoImageContainer = document.createElement('div');
		infoImageContainer.classList.add('timeline-block-info-image');
		info.appendChild(infoImageContainer);

		//add image
		const infoImage = new Image();
		
		infoImage.onload = () => {
			infoImageContainer.appendChild(infoImage);
		}

		infoImage.src = this.person.picture.thumbnail;

		//add top info text
		const infoText = document.createElement('div');
		infoText.classList.add('timeline-block-info-text');

		info.appendChild(infoText);

		//make name
		const infoName = document.createElement('p');
		infoName.textContent = this.person.name.first + ' ' + this.person.name.last;
		infoText.appendChild(infoName);

		//make date
		const infoDate = document.createElement('p');
		infoDate.textContent = `${moment().format('MMMM D')} at ${moment().format('h:mma')}`;

		infoText.appendChild(infoDate);

		//make body
		const body = document.createElement('div');
		body.classList.add('timeline-block-body');
		this.parent.appendChild(body);

		//make text
		const bodyText = document.createElement('p');
		bodyText.textContent = this.photo.message;
		body.appendChild(bodyText);

		//add image
		const bodyImage = new Image();

		bodyImage.onload = () => {
			body.appendChild(bodyImage);

			//add response emojis
			const responseEmojis = document.createElement('div');
			responseEmojis.classList.add('responseEmojis');

			body.appendChild(responseEmojis);

			//add default like
			const like = document.createElement('div');
			like.classList.add('response');
			like.style.width = '20px';
			like.style.height = '20px';
			like.style.background = 'url(img/icon_like.png) no-repeat center center';
			like.style.backgroundSize = 'contain';

			responseEmojis.appendChild(like);


			//--------------------------------------------
			// FINISH!!!!
			//
					
			self.deferred.resolve(self.parent);
		}

		bodyImage.onerror = () => {
			bodyImage.src = '';
			self.deferred.resolve(self.parent);
		}

		bodyImage.src = this.photo.image;


	}


	show(){
		if (this.parent){
			this.parent.classList.add('visible');
			this.visible = true;
		}
	}

	onClick(ev){
		ev.preventDefault();

		this.parent.classList.remove('visible');
		this.visible = false;

		this.scene.addSprites('img/icon_like.png');
		AudioManager.onMessageOff();

		setTimeout(() => {
			this.parent.remove();
		}, 1000);
	}

}

export default TimelinePost;